const ensureCheckboxEnabled = () => {
    const availabilityParam = 'filter.v.availability';
    const availabilityValue = '1';

    // Si la URL no contiene el filtro de disponibilidad, lo añadimos
    const urlParams = new URLSearchParams(window.location.search);
    let hasFilterV = false;
    for (const key of urlParams.keys()) {
        if (key.startsWith('filter.v')) {
        hasFilterV = true;
        break;
        }
    }

    if (hasFilterV && !urlParams.has(availabilityParam)) {
        urlParams.set(availabilityParam, availabilityValue);
        const newUrl = `${window.location.pathname}?${urlParams.toString()}`;
        window.location = newUrl.toString();
    }
};

const observer = new MutationObserver(() => {
    ensureCheckboxEnabled();
});

observer.observe(document.body, { childList: true, subtree: true });

ensureCheckboxEnabled();